export default "__VITE_ASSET__791a46f1__"